import React from 'react';
import { useScheduleContext } from '../../../../context/ScheduleContext';
import { useLocaleContext } from '../../../../context/LocaleContext';
import { useStreamContext } from '../../../../context/StreamContext';
import { unixFormat, isSameAs } from '../../../../helpers/times';
import { capitalizer } from '../../../../../../cp/utils';
import { TABS_TYPE, PAGE_TYPE, HIDE_TYPE } from '../../../../constants/page-settings/schedule';
import ScheduleEpisodes from '../../ScheduleEpisodes';
import { useApplicationContext } from '../../../../context/ApplicationContext';

import './style.scss';

const ScheduleLineAndTileView = ({ isActiveFavorites, onEpisodeClick, checkAuth, onRateEpisode, currentUser }) => {
    const {page, schedule, scheduleFilters, isWidget, widgetSettings, episodes} = useScheduleContext();
    const streamContext = useStreamContext();
    const $locale = useLocaleContext();
    const { bookmarkEpisodeIds } = useApplicationContext();

    if (isActiveFavorites) {
        return (
            <div className="schedule-view">
                <ScheduleEpisodes
                    episodes={episodes.filter(({id, streamId}) => {
                        return bookmarkEpisodeIds.includes(id) &&
                        (page.template === "program" || streamId === streamContext.stream.id)
                    })}
                    isActiveFavorites={isActiveFavorites}
                    onEpisodeClick={onEpisodeClick}
                    checkAuth={checkAuth}
                    onRateEpisode={onRateEpisode}
                    currentUser={currentUser}
                />
            </div>
        )
    }

    if (isWidget
        ? widgetSettings?.daysView === PAGE_TYPE && (widgetSettings?.hallsView === TABS_TYPE || widgetSettings.hallsView === HIDE_TYPE)
        : page.settings.daysView === PAGE_TYPE && (page.settings.hallsView === TABS_TYPE || page.settings.hallsView === HIDE_TYPE)
    ) {
        return (
            <div className="schedule-view">
                {
                    scheduleFilters.scheduleDates.map(({value: scheduleDate}) => (
                        <React.Fragment key={scheduleDate}>
                            {
                                schedule.some(({timeStart}) => isSameAs(timeStart, scheduleDate)) &&
                                <div className="schedule-view-date">
                                    {capitalizer(unixFormat(scheduleDate, 'dddd DD MMMM YYYY'))}
                                </div>
                            }
                            <ScheduleEpisodes
                                episodes={schedule.filter(({timeStart}) => isSameAs(timeStart, scheduleDate))}
                                checkAuth={checkAuth}
                                onRateEpisode={onRateEpisode}
                                currentUser={currentUser}
                            />
                        </React.Fragment>
                    ))
                }
            </div>
        )
    }

    if (isWidget
        ? widgetSettings?.daysView === TABS_TYPE && widgetSettings?.hallsView === PAGE_TYPE
        : page.settings.daysView === TABS_TYPE && page.settings.hallsView === PAGE_TYPE
    ) {
        return (
            <div className="schedule-view">
                {
                    streamContext.streams.map((stream) => (
                        <React.Fragment key={stream.id}>
                            {
                                schedule.some(({streamId}) => streamId === stream.id) &&
                                <div
                                    className="schedule-view-hall"
                                    style={{borderColor: stream.color || 'none'}}
                                >
                                    {$locale.getProperty(stream, 'description')}
                                </div>
                            }
                            <ScheduleEpisodes
                                episodes={schedule.filter(({streamId}) => streamId === stream.id)}
                                checkAuth={checkAuth}
                                onRateEpisode={onRateEpisode}
                                currentUser={currentUser}
                            />
                        </React.Fragment>
                    ))
                }
            </div>
        )
    }

    if (isWidget
        ? widgetSettings?.daysView === PAGE_TYPE && widgetSettings?.hallsView === PAGE_TYPE
        : page.settings.daysView === PAGE_TYPE && page.settings.hallsView === PAGE_TYPE
    ) {
        return (
            <div className="schedule-view">
                {
                    scheduleFilters.scheduleDates.map(({value: scheduleDate}) => (
                        <React.Fragment key={scheduleDate}>
                            {
                                schedule.some(({timeStart}) => isSameAs(timeStart, scheduleDate)) &&
                                <div className="schedule-view-date">
                                    {capitalizer(unixFormat(scheduleDate, 'dddd DD MMMM YYYY'))}
                                </div>
                            }
                            {
                                streamContext.streams.map((stream) => (
                                    <React.Fragment key={stream.id}>
                                        {
                                            schedule.some(({timeStart, streamId}) => isSameAs(timeStart, scheduleDate) && streamId === stream.id) &&
                                            <div
                                                className="schedule-view-hall"
                                                style={{borderColor: stream.color || 'none'}}
                                            >
                                                {$locale.getProperty(stream, 'description')}
                                            </div>
                                        }
                                        <ScheduleEpisodes
                                            episodes={schedule.filter(({timeStart, streamId}) => isSameAs(timeStart, scheduleDate) && streamId === stream.id)}
                                            checkAuth={checkAuth}
                                            onRateEpisode={onRateEpisode}
                                            currentUser={currentUser}
                                        />
                                    </React.Fragment>
                                ))
                            }
                        </React.Fragment>
                    ))
                }
            </div>
        )
    }

    return (
        <div className="schedule-view">
            <ScheduleEpisodes
                episodes={schedule}
                checkAuth={checkAuth}
                onRateEpisode={onRateEpisode}
                currentUser={currentUser}
            />
        </div>
    )
};

export default ScheduleLineAndTileView;
